import React, { useState } from 'react'
import { HeaderContent, HomeStyles } from '../styles'
import { Row } from '../../../../components/commons'
import ModalCreateFolder from '../../../../components/Modals/ModalCreateFolder'
import { useDirectory } from '../../../../store/directory'
import { useUserStore } from '../../../../store/user'
import { usePermissions } from '../../../../hooks/usePermissions'
import ModalUpload from '../../../../components/Modals/ModalUpload'
import ModalDelete from '../../../../components/Modals/ModalDelete'
import ModalCopyFolder from '../../../../components/Modals/ModalCopyFolder'
import { api } from '../../../../services/api'
import useToast from '../../../../hooks/useToast'
import { Tooltip } from 'react-tooltip'
import { FaChevronRight, FaDownload, FaPlus, FaTrash, FaUpload, FaFolderOpen } from 'react-icons/fa6'
import { ButtonRound } from '../../../../components/Header/styles'
import UserPerMission from '../UsersPermission'
import { theme } from '../../../../styles/theme'
import axios from 'axios'
import { ResponseError } from '../../../../validators/utils.interface'

export interface BreadCrumbProps {
  refetch: () => void
  fileRefs?: any
}

type CreateModalRef = React.ElementRef<typeof ModalCreateFolder>
type ModalUploadRef = React.ElementRef<typeof ModalUpload>
type ModalDeleteRef = React.ElementRef<typeof ModalDelete>
type ModalCopyFolderRef = React.ElementRef<typeof ModalCopyFolder>

const BreadCrumb: React.FunctionComponent<BreadCrumbProps> = ({ refetch, fileRefs }) => {
  const modalCreateFolder = React.useRef<CreateModalRef>(null)
  const modalRef = React.useRef<ModalUploadRef>(null)
  const modalDeleteRef = React.useRef<ModalDeleteRef>(null)
  const modalCopyFolderRef = React.useRef<ModalCopyFolderRef>(null)

  const [isLoading, setisLoading] = React.useState(false)

  const toast = useToast()
  const { user } = useUserStore()
  const { canCreateDocuments, canDeleteDocuments, canEditDocuments } = usePermissions()

  const directory = useDirectory((state) => state.directory)

  // Verificar permissões baseadas em grupo ao invés de role do usuário
  const canCreate = canCreateDocuments
  const canDelete = canDeleteDocuments
  const canEdit = canEditDocuments

  const onSelectFolder = (index: number) => {
    let directories = [...directory]

    directories.splice(index + 1)

    useDirectory.getState().setDirectory(directories)
  }

  const handleDownload = async () => {
    let selectedDocuments: any = []

    fileRefs.current.map((ref: any) => {
      if (ref?.current?.checked) {
        selectedDocuments.push({ 
          _id: ref.current?._id, 
          name: ref.current.name,
          isFolder: ref.current.isFolder 
        })
      }
    })

    if (!selectedDocuments.length) return toast.errorToast('Selecione um documento!')

    // Verificar se há pastas selecionadas
    const hasFolders = selectedDocuments.some((doc: any) => doc.isFolder)
    if (hasFolders) return toast.errorToast('Não é possível baixar pastas! Selecione apenas documentos.')

    await Promise.all(
      selectedDocuments.map(async (doc: any) => {
        try {
          // Obter link de compartilhamento do Dropbox
          const { data: response } = await api.get(`/documents/${doc._id}`)
          
          if (response.success && response.shareLink) {
            // Adicionar parâmetro dl=1 para download direto
            const downloadUrl = response.shareLink.includes('?') 
              ? `${response.shareLink}&dl=1`
              : `${response.shareLink}?dl=1`
            
            // Criar link temporário para download
            const link: any = document.createElement('a')
            link.href = downloadUrl
            link.download = doc.name
            link.target = '_blank'
            
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else {
            toast.errorToast(`Erro ao obter link para ${doc.name}`)
          }
        } catch (error) {
          toast.errorToast(`Erro ao baixar ${doc.name}`)
        }
        return true
      }),
    )

    toast.successToast('Downloads iniciados com sucesso')
  }

  const onDeleteFoldes = async (ids: any) => {
    try {
      setisLoading(true)

      await Promise.all(
        ids.map(async (id: any) => {
          await api.delete(`/documents/${id}`)
        }),
      )

      refetch()
      modalDeleteRef.current?.closeModal()
      toast.successToast('Todos arquivos foram deletados')
    } catch (error) {
      const typedError = error as ResponseError
      if (axios.isAxiosError(error)) {
        console.log(typedError)
        toast.errorToast(typedError?.response?.data?.message)
      } else {
        toast.errorToast('Erro ao deletar o registro !')
      }
    } finally {
      setisLoading(false)
      modalDeleteRef.current?.closeModal()
    }
  }

  const onPressDelete = () => {
    let ids: any = []

    fileRefs.current.map((ref: any) => {
      

      if (ref?.current?.checked) {
        ids.push(ref.current._id)
      }
    })
    if (ids.length > 0) {
      modalDeleteRef.current?.openModal(ids)
    } else {
      toast.errorToast('Selecione um arquivo')
    }
  }

  const [selectedItems, setSelectedItems] = useState<any[]>([])

  const onPressMove = () => {
    let items: any = []

    fileRefs.current.map((ref: any) => {
      if (ref?.current?.checked) {
        items.push({ 
          _id: ref.current?._id, 
          name: ref.current.name,
          isFolder: ref.current.isFolder 
        })
      }
    })

    if (!items.length) {
      return toast.errorToast('Selecione um documento ou pasta para mover!')
    }

    setSelectedItems(items)
    modalCopyFolderRef.current?.openModal()
  }

  return (
    <>
      <Tooltip
        id='my-tooltip'
        style={{ backgroundColor: theme.colors.primary, zIndex: 9999, color: 'white' }}
      />
      <Row gap={15} align='center' justify='center'>
        <HeaderContent.BreadCumbs style={{ marginRight: 'auto' }}>
          {directory.map((bread, index) => (
            <div
              key={bread.name}
              style={{
                display: 'inline-block',
              }}
            >
              <HomeStyles.Row onClick={() => onSelectFolder(index)}>
                <HomeStyles.BreadName>{bread.name}</HomeStyles.BreadName>
                {index < directory.length - 1 ? <FaChevronRight size={10} /> : ''}
              </HomeStyles.Row>
            </div>
          ))}
        </HeaderContent.BreadCumbs>
        <Row gap={10} align='center' justify='center'>

          {canEdit && <UserPerMission fileRefs={fileRefs} onSubmitButton={() => {}} />}
          {canEdit && (
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Mover Pasta/Documento'
              data-tooltip-place='top'
              onClick={onPressMove}
            >
            <FaFolderOpen color='white' />
            </ButtonRound>
          )}
          {canCreate && (
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Enviar documento'
              data-tooltip-place='top'
              onClick={() => modalRef.current?.openModal()}
            >
              <FaUpload color='white' />
            </ButtonRound>
          )}
          {canDelete && (
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Excluir documentos'
              data-tooltip-place='top'
              onClick={() => onPressDelete()}
            >
              <FaTrash color='white' />
            </ButtonRound>
          )}
          {canCreate && (
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Criar nova pasta'
              data-tooltip-place='top'
              onClick={() => modalCreateFolder.current?.openModal()}
            >
              <FaPlus color='white' />
            </ButtonRound>
          )}
          <ButtonRound
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Realizar download'
            data-tooltip-place='top'
            onClick={() => handleDownload()}
          >
            <FaDownload color='white' />
          </ButtonRound>
        </Row>
      </Row>

      <ModalCopyFolder refetch={refetch} ref={modalCopyFolderRef} selectedItems={selectedItems} />
      <ModalCreateFolder refetch={refetch} ref={modalCreateFolder} />
      <ModalUpload refetch={refetch} ref={modalRef} />
      <ModalDelete
        loading={isLoading}
        title='Deseja deletar esses arquivo(s)?'
        onSubmitButton={onDeleteFoldes}
        ref={modalDeleteRef}
      />
    </>
    //<ModalCopyFolder refetch={refetch} ref={modalCopyFolderRef} />
    //<ModalCreateFolder refetch={refetch} ref={modalCreateFolder} />
    //<ModalUpload refetch={refetch} ref={modalRef} />
  )
}

export default BreadCrumb
